module.exports = __webpack_public_path__ + "static/media/2_transformed.6cf005e2.png";